import {
  getStyleguideClasses,
  getUiLibraryClasses,
  isMyAccount,
} from '../utils';

let FORM = {};

FORM.init = function () {
  let inputSelector = 'input:not([type=checkbox]), select';
  // open:countrydropdown handles country code selector input
  // for phone numbers
  // ~ in the selector handles labels for multiple input fields
  $(inputSelector).on('focus open:countrydropdown', function () {
    let inputInFocus = $(this).attr('id');
    let lbl = $('label[for~="' + inputInFocus + '"]');

    if (lbl.length > 0) {
      lbl.addClass('focused');
    }
  });

  // open:countrydropdown handles country code selector input
  // for phone numbers
  // ~ in the selector handles labels for multiple input fields
  $(inputSelector).on('blur close:countrydropdown', function () {
    let inputInFocus = $(this).attr('id');
    let lbl = $('label[for~="' + inputInFocus + '"]');

    if (lbl.length > 0) {
      lbl.removeClass('focused');
    }
  });

  $('.js-loading-btn').click(function () {
    const legacyPagesButtonIds = [
      'makeTheOrder',
      'insertCouponButton',
      'makeThePaypalOrder',
      'insertCouponFromMessageButton',
      'updateDeliveryAddressButton',
      'editPaymentSubmit',
      'marketplacePaypalButton',
    ];
    const btnLoadingClassArr = legacyPagesButtonIds.includes($(this).attr('id'))
      ? getUiLibraryClasses(['btn--loading'])
      : getStyleguideClasses(['btn--loading']);
    $(this).addClass(...btnLoadingClassArr);
  });

  $('#goToPreview').click(function (e) {
    if ($('.btn-disabled').length) {
      e.preventDefault();
      $(this).removeClass(...getStyleguideClasses(['btn--loading']));
      $(this).attr('aria-disabled', 'true');
    }
  });

  $('#makeTheOrder').on('dblclick', function (event) {
    event.preventDefault();
  });

  $('.js-checkout form').submit(function () {
    let submitBtn = $(this).find('button[type=submit]');
    submitBtn.attr('disabled', 'disabled');
  });

  //  Add error icon on every input element with ERROR class set.
  appendIcontoInput('ERROR', 'error-circle');

  accordionPanel();
  initAccordionPanel();

  $('.js-agreement, .js-sameAsShipping').change(function () {
    let $parentContainer = $(this).parent(
      '.form__agreement, .checkbox__wrapper, .single__checkbox'
    );
    $parentContainer.toggleClass('selected');
    $parentContainer.removeClass('ERROR');
  });

  showPassword();
};

function appendIcontoInput(elemClass, iconName) {
  let iconElem = `<svg class="checkout__icon error__icon" aria-hidden="true"><use xlink:href="#${iconName}"></use></svg>`;
  $(
    'input[type=text].' +
      elemClass +
      ', input[type=password].' +
      elemClass +
      ', input[type=email].' +
      elemClass +
      ', textarea.' +
      elemClass
  ).after(iconElem);
}

function accordionPanel() {
  $('.accordion__panel input[type=radio]').change(function () {
    //  If the radio button is in the form which is in one accordion panel.
    if ($(this).parents('.panel__content').length > 0) {
      return;
    }
    let $activeAccordionPanel = isMyAccount
      ? $(this)
          .parents('.main__wrapper__account .accordion__container')
          .find('.accordion__panel.active')
          .not('.sub__panel')
      : $(this)
          .parents('.main__wrapper .accordion__container')
          .find('.accordion__panel.active')
          .not('.sub__panel');

    let $selectedAccordionPanel = isMyAccount
      ? $(this).parent('.main__wrapper__account .accordion__panel')
      : $(this).parent('.main__wrapper .accordion__panel');

    $activeAccordionPanel.removeClass('active');
    $activeAccordionPanel.attr('aria-expanded', 'false');
    $activeAccordionPanel
      .find('input, select')
      .not('input[type=radio]')
      .attr('disabled', true);

    $selectedAccordionPanel.addClass('active');
    $selectedAccordionPanel.attr('aria-expanded', 'true');
    $selectedAccordionPanel
      .find('input, select')
      .not('input[type=radio]')
      .attr('disabled', false);
  });

  accordionSubPanel();
}

function accordionSubPanel() {
  $('.accordion__panel.sub__panel input[type=radio]').change(function () {
    let $activeAccordionPanel = $(this).parents().find('.sub__panel.active');
    let $selectedAccordionPanel = $(this).parent(
      '.accordion__panel.sub__panel'
    );

    // Clean sub panel when changing to another
    let errors = $activeAccordionPanel.find('.js-adyenFormValidation');
    errors.addClass('hidden');
    $activeAccordionPanel.find('.form__field ').removeClass('ERROR');

    $activeAccordionPanel.removeClass('active');
    $activeAccordionPanel
      .find('input, select')
      .not('input[type=radio]')
      .attr('disabled', true);

    $selectedAccordionPanel.addClass('active');
    $selectedAccordionPanel
      .find('input, select')
      .not('input[type=radio]')
      .attr('disabled', false);

    let parentPanel = $(this).parents('.accordion__panel.parent__panel');
    $(parentPanel).find('input.parent__radio').val($(this).val());
  });
}

function initAccordionPanel() {
  let $notActiveAccordionPanel = isMyAccount
    ? $('.main__wrapper__account .accordion__panel:not(.active)')
    : $('.main__wrapper .accordion__panel:not(.active)');
  $notActiveAccordionPanel
    .find('input, select')
    .not('input[type=radio]')
    .attr('disabled', true);
}

function showPassword() {
  let checkBox = $('#showPassword');
  let field = $('#customerPassword');

  checkBox.click(function () {
    checkBox.toggleClass('checked');
    if (checkBox.hasClass('checked')) {
      field.attr('type', 'text');
    } else {
      field.attr('type', 'password');
    }
  });
}

FORM.setAccordionPanelEvent = accordionPanel();

export default FORM;
export { accordionPanel as setAccordionPanelEvent };
